import { Fragment } from 'react';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { weatherIcons } from './Weather.model';
import { StyledWeatherIcon } from './Weather.styled';

const Weather = () => {
	const weather = useObservable(rage.weather.getWeather());

	return (
		<Fragment>
			<StyledWeatherIcon src={weatherIcons[weather.weather]} />
			<Text style={{ fontWeight: 700, fontSize: '18px' }}>
				{weather.degrees > 0 ? `+${weather.degrees}` : weather.degrees}°
			</Text>
		</Fragment>
	);
};

export { Weather };
